<template>

  <v-container fluid grid-list-md class="grey lighten-5" >
    <v-row>
      <v-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
        <h1 class="pl-4">{{this.$store.state.documentActivLoc}}</h1>
      </v-col>
      <v-col cols="12" xs="12" sm="12" md="9" lg="5" xl="5" class="text-right">
        <span v-if="showCreateInv"><v-btn text @click="createInv1">{{lang.createInv}}</v-btn></span>
        <!-- Isto kao gore, ali nastaju racuni na kasi: placanje transakcijskim
             racunom i BEZ fiskalizacije. -->
        <span v-if="showCreateInv"><v-btn text @click="otvoriPosRacune">Kreiraj POS rač.</v-btn></span>
        <v-btn text @click="warehouseSelected">{{currWh}}</v-btn>
        <span v-if="$store.state.documentActiv !== 'ServiceNotes'">
          <v-btn text @click="openStatus">{{lang.documentTypesHeader}}</v-btn>
        </span>
      </v-col>
      <v-col cols="12" xs="12" sm="12" md="3" lg="1" xl="1" class="text-right pb-4">
          <v-btn fab dark fixed right class="indigo"  @click="newdocument">
              <v-icon dark>mdi-plus</v-icon>
          </v-btn>
      </v-col>
    </v-row>

    <v-row >
      <v-col cols="12" sm="12" md="12" lg="12" xl="12">
        <Documentlist :key="key" />
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pl-3">
        <v-btn color="primary" @click="digitalDoc" class="mr-2 mb-4" >
            {{lang.DigitalAr}}
          </v-btn>
      </v-col>
    </v-row>
    <v-row no-gutters v-if="showDigitalDoc">
      <v-col cols="12" sm="12" md="12" lg="12" xl="12">
        <DigitalDocFullList />
      </v-col>
    </v-row>
    <v-row>

    </v-row>
    <v-snackbar
      v-model="snackbar"
      bottom
      :timeout="timeout"
      :color="color"
      >
      {{ text }}
    </v-snackbar>
    <div v-if="showWarehouse">
      <WareHouseSelect v-on:closedDialog="closedDialog2"/>
    </div>
    <div v-if="showCreateInvModal">
      <v-dialog
        v-model="dialog"
        width="auto"
      >
        <v-card>
          <v-card-title class="headline">
            {{ posNacin ? 'Kreiraj POS račune iz ugovora' : lang.createInv2 }}
          </v-card-title>
          <v-card-text>
            <v-alert v-if="posNacin" type="info" dense text class="mb-2">
              Nastaju računi na kasi, plaćanje <b>transakcijskim računom</b>.
              Računi se <b>ne fiskaliziraju</b> — pošaljite ih poslije iz popisa
              računa kase.
            </v-alert>
            <div v-if="posNacin && posPregled" class="mb-3">
              <span v-if="posPregled.bilo_bi">
                Izdat će se <b>{{ posPregled.bilo_bi }}</b>
                {{ posPregled.bilo_bi === 1 ? 'račun' : 'računa' }},
                ukupno <b>{{ posPregled.ukupno }}</b> EUR.
              </span>
              <span v-if="!posPregled.bilo_bi" class="red--text">
                {{ posPregled.poruka || 'Nema ugovora za koje bi se izdali računi.' }}
              </span>

              <!-- Ugovor ostaje važeći i kad je sklopljen ranijih godina, pa se
                   računi izdaju i po njima. To zna biti iznenađenje jer ih je
                   tada puno više nego što se očekuje. -->
              <div v-if="posPregled.poGodinamaUgovora && posPregled.poGodinamaUgovora.length > 1"
                class="mt-1 caption orange--text text--darken-3">
                Ugovori su iz više godina:
                <span v-for="(g, i) in posPregled.poGodinamaUgovora" :key="g.godina">
                  <span v-if="i">, </span>{{ g.godina }}. — {{ g.ugovora }}
                </span>.
                Računi se izdaju po svima koji su označeni kao važeći.
              </div>

              <div v-if="posPregled.upozorenja && posPregled.upozorenja.length"
                class="mt-1 caption red--text">
                {{ posPregled.upozorenja.length }}
                {{ posPregled.upozorenja.length === 1 ? 'kupac nema' : 'kupaca nema' }}
                ispravan OIB, a nisu označeni kao privatne osobe. Računi se svejedno
                izdaju — plaćanje je transakcijskim računom, pa se OIB Poreznoj ne šalje —
                ali podatke u šifrarniku partnera vrijedi ispraviti.
              </div>
            </div>
             <v-row>
              <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" >
                {{lang.DocumentDate}}: <input type="date" v-model="inv_documentDate" />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" >
                {{lang.documentTime}}: <input type="time" v-model="inv_documentTime" />
              </v-col>
            </v-row>
            <v-row v-if="!posNacin">
              <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                {{lang.DeadLine}}: <input type="date" v-model="inv_documentInvoiceEndDate" />
              </v-col>
            </v-row>
            <v-row v-if="!posNacin">
              <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                {{lang.startPeriod}} <input type="date" v-model="inv_documentInvoiceStartDate" />
              </v-col>
            </v-row>
            <v-row v-if="!posNacin">
              <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                {{lang.endPeriod}} <input type="date" v-model="inv_documentInvoiceEndPeriodDate" />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <v-text-field class="pr-3"
                  label="Dodatak opisu:"
                  v-model="inv_Description"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-row>
              <v-col cols="6" xs="6" sm="6" md="6" lg="6" xl="6">
                <v-btn color="primary" :disabled="posNacin && posPregled && !posPregled.bilo_bi"
                  @click="posNacin ? kreirajPosRacune() : dialogSt()">Kreiraj</v-btn>
              </v-col>
               <v-progress-circular v-if="this.saving"
                  indeterminate
                  color="green"
                ></v-progress-circular>
              <v-col cols="6" xs="6" sm="6" md="6" lg="6" xl="6">
                <v-btn color="red"  @click="createInv1">{{langC.Cancel}}</v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
               <v-progress-linear v-if="this.saving"
                  indeterminate
                  color="green"
                ></v-progress-linear>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import Documentlist from './DocumentList'
import DigitalDocFullList from '@/components/DigitalDoc/DigitalDocFullList'
import WareHouseSelect from '../WareHouse/WareHouseSelect'
import DocumentService from '@/services/DocumentService'
import DocumentDetailService from '@/services/DocumentDetailService'
import KasaService from '@/services/KasaService'
// import DocumentTest2D from './DocumentTest2D'
import langEn from './documentDescEn'
import langHr from './documentDescHR'
// Nazivi vrsta dokumenata onako kako pisu u izborniku - da naslov bude isti
// bez obzira je li se doslo kroz izbornik ili izravno na adresu.
import mainEn from '@/components/mainDescEN'
import mainHr from '@/components/mainDescHR'
import commEn from '@/language/commonEN'
import commHr from '@/language/commonHR'
import { mapGetters } from 'vuex'
import { v4 as uuidv4 } from 'uuid'
import dayjs from 'dayjs'

export default {
  name: 'document',
  data () {
    return {
      saving: false,
      snackbar: false,
      text: '',
      timeout: 2000,
      color: 'green',
      dialog: false,
      msg: '',
      documentName: '',
      documentNameLoc: '',
      routeto: 1,
      lang: {},
      langC: {},
      showDigitalDoc: false,
      showWarehouse: false,
      currWh: '',
      localWH: 1,
      key: 1,
      showCreateInv: false,
      posNacin: false,
      posPregled: null,
      showCreateInvModal: false,
      inv_documentDate: null,
      inv_documentTime: null,
      inv_documentInvoiceStartDate: null,
      inv_documentInvoiceEndDate: null,
      inv_documentInvoiceEndPeriodDate: null,
      inv_Description: '',
      banks: [],
      mainQuery: {},
      UUID: null,
      QRcodeLink: null
    }
  },
  created () {
    // Isto kao kod knjige URA: koja se vrsta dokumenta gleda postavlja izbornik
    // (markMe u AppNavigation). Kad se na adresu dodje mimo izbornika -
    // bookmark, osvjezena stranica - "documentActiv" je prazan, pa je naslov
    // ostajao prazan, a upit je bio bez vrste dokumenta i vracao sve dokumente
    // izmijesane (racune, ponude, primke, radne naloge). Tada otvaramo racune.
    //
    // Ide u "created" jer se popis stvara prije roditeljskog "mounted", i bez
    // "await" jer je commit u storeu sinkron.
    if (!this.$store.state.documentActiv) {
      const nazivi = this.$store.state.language === 'EN' ? mainEn : mainHr
      this.$store.dispatch('setDocumentActiv', 'InvoiceSales')
      this.$store.dispatch('setDocumentActivLoc', nazivi.Invoices)
      this.$store.dispatch('setDocumentSide', 3)
    }
  },
  async mounted () {
    if (this.$store.state.language === 'EN') {
      this.lang = langEn
      this.langC = commEn
    }
    if (this.$store.state.language === 'HR') {
      this.lang = langHr
      this.langC = commHr
    }

    this.documentName = this.$store.state.documentActiv
    this.documentNameLoc = this.$store.state.documentActivLoc
    if (this.$store.state.documentActiv === 'WorkingOrder') {
      this.routeto = 2
    }
    if (this.$store.state.documentActiv === 'ContractSales') {
      this.showCreateInv = true
    }
    this.localWH  = this.$store.state.warehousemarkid ? 'Akt.skl. ' + this.$store.state.warehousemarkid : 1
    this.currWh = this.localWH
    this.inv_documentDate = dayjs(new Date()).format('YYYY-MM-DD')
    this.inv_documentTime = dayjs(new Date()).format('HH:mm')
    this.inv_documentInvoiceEndDate = dayjs(new Date()).add(15, 'days').format('YYYY-MM-DD')
    this.inv_documentInvoiceStartDate = dayjs(new Date()).format('YYYY-MM-DD')
    this.inv_documentInvoiceEndPeriodDate = dayjs(new Date()).add(15, 'days').format('YYYY-MM-DD')
  },
  methods: {
    createInv1() {
      this.posNacin = false
      this.posPregled = null
      this.showCreateInvModal = !this.showCreateInvModal
      this.dialog = !this.dialog
    },

    // Prije skupnog izdavanja se pita posluzitelja sto bi nastalo - da se ne
    // izda pedeset racuna pa se tek onda vidi da nesto ne valja.
    async otvoriPosRacune () {
      this.posNacin = true
      this.posPregled = null
      this.showCreateInvModal = true
      this.dialog = true
      try {
        const {data} = await KasaService.izUgovora({
          CompanyId: this.$store.state.companyid,
          BusinessYear: this.$store.state.businessYear,
          SKLADID: this.$store.state.warehousemarkid || 1,
          datum: this.inv_documentDate,
          vrijeme: this.inv_documentTime,
          dodatakOpisu: this.inv_Description,
          pregled: true
        })
        this.posPregled = data
      } catch (err) {
        this.posPregled = {bilo_bi: 0, poruka: this.greskaTeksta(err)}
      }
    },

    async kreirajPosRacune () {
      this.saving = true
      try {
        const {data} = await KasaService.izUgovora({
          CompanyId: this.$store.state.companyid,
          BusinessYear: this.$store.state.businessYear,
          SKLADID: this.$store.state.warehousemarkid || 1,
          datum: this.inv_documentDate,
          vrijeme: this.inv_documentTime,
          dodatakOpisu: this.inv_Description
        })
        this.dialog = false
        this.showCreateInvModal = false
        this.posNacin = false
        this.text = data.napravljeno
          ? `${data.poruka} Brojevi ${data.odBroja}–${data.doBroja}, ukupno ${data.ukupno} EUR.`
          : data.poruka
        this.color = data.napravljeno ? 'green' : 'orange darken-2'
        this.snackbar = true
        this.timeout = 6000
      } catch (err) {
        this.text = this.greskaTeksta(err)
        this.color = 'red'
        this.snackbar = true
        this.timeout = 6000
      } finally {
        this.saving = false
      }
    },

    greskaTeksta (err) {
      const t = err && err.response && err.response.data ? err.response.data : null
      if (t && t.greska) { return t.greska }
      return err && err.message ? err.message : 'Nepoznata greška.'
    },
    warehouseSelected() {
      this.showWarehouse = !this.showWarehouse
    },
    closedDialog2() {
      this.showWarehouse = false
    },
    async dialogSt() {
      this.QRcodeLink = null
      this.QRcodeLink = uuidv4()
      const emptArr = []
      const newHeads = [...emptArr]
      const newDetails = [...emptArr]

      this.mainQuery.CompanyId = this.$store.state.companyid
      // last NR
      this.mainQuery.documentName = 'InvoiceSales'
      this.mainQuery.BusinessYear = this.$store.state.businessYear ? this.$store.state.businessYear : 2023
      let lastNr = parseInt((await DocumentService.choose(this.mainQuery)).data.docNumber)

      // doc details
      delete this.mainQuery.BusinessYear
      this.mainQuery.documentName = 'ContractSales'
      const docDetails = (await DocumentDetailService.alldocdetails(this.mainQuery)).data.docdetails

      this.saving = true
      await DocumentService.docsall(this.mainQuery).then(async(res) => {
        const heads = res.data.documents ? res.data.documents : []

        if (!heads) {
          this.dialog = false
          this.text = 'Error! List of contract are empty! Greška! Nema ugovora za kreiranje računa!'
          this.color = 'red'
          this.snackbar = true
          this.timeout = 4000
        }
        if (heads) {
          console.log('heads', heads)

          heads.map(head => {
            if (head.validContract) {
              const nI = {...head}
              delete nI.id
              nI.UserId = this.$store.state.user.id ? this.$store.state.user.id : ''
              nI.email = this.$store.state.user.email ? this.$store.state.user.email : 'test@cegrupa.com'
              nI.First = this.$store.state.user.First ? this.$store.state.user.First : 'NoFirst'
              nI.Last = this.$store.state.user.Last ? this.$store.state.user.Last : 'NoLast'
              nI.BusinessYear = this.$store.state.businessYear ? this.$store.state.businessYear : 2023
              nI.documentName = 'InvoiceSales'
              nI.documentAnalysis = 1
              nI.documentSide = 3
              nI.documentDescription5 = this.$store.state.companyActiv.CompanyInvoiceMemo
              nI.documentDate = this.inv_documentDate
              nI.documentTime = this.inv_documentTime
              nI.documentInvoiceStartDate = this.inv_documentInvoiceStartDate
              nI.documentInvoiceEndDate = this.inv_documentInvoiceEndDate
              nI.documentInvoiceEndPeriodDate = this.inv_documentInvoiceEndPeriodDate

              nI.documentId = lastNr
              nI.documentIdGeneral = this.$store.state.companyName + '-' + this.$store.state.businessYear + '-InvoiceSales-' + lastNr + '-' + (this.$store.state.warehousemarkid ? this.$store.state.warehousemarkid : 1)

              nI.eRacun = true
              nI.eRacunPoslovniProces = "P1-Fakturiranje isporuka dobara i usluga preko narudžbi na temelju ugovora"
              nI.eRacunPoslovniProcesSifra = "P1"

              nI.TipDokumenta = 'Komercijalni račun'
              nI.TipDokumentaBroj = '380'

              nI.RespondedID = null
              nI.RespondedDate = null
              nI.RespondedMessage = null
              nI.RespondedStatus = null
              nI.RespondedReason = null

              // uuid
              this.UUID = uuidv4()
              nI.UUID = this.UUID
              nI.QRcodeLink = this.QRcodeLink
              newHeads.push(nI)
              lastNr += 1

              const filDet = docDetails.filter(items => items.databaseDocID === parseInt(head.id))
              if (filDet) {

                filDet.map(itemD => {
                  const nd = {...itemD}
                  delete nd.id
                  delete nd.databaseDocID
                  nd.BusinessYear = this.$store.state.businessYear ? this.$store.state.businessYear : 2023
                  nd.documentName = 'InvoiceSales'
                  nd.documentAnalysis = 1
                  nd.documentSide = 3
                  nd.UUID = this.UUID
                  newDetails.push(nd)
                })
              }
            }
          })


          // if newHeads bulkcreate Heads route
          if (newHeads && newHeads.length > 0) {
            await DocumentService.saveinvoices(newHeads)
                .then(async(response) => {
                  const query2 = {}
                  query2.CompanyId = this.$store.state.companyid
                  query2.QRcodeLink = this.QRcodeLink
                  //const savedHeads = (await DocumentService.choose(query2)).data.documents

                  await DocumentService.findallbyuuid(query2)
                  .then(async(res3) => {
                    const savedHeads = res3 && res3.data && res3.data.documents ? res3.data.documents : []

                    if (savedHeads) {
                      newDetails.map(detail => {
                        const newHead = savedHeads.find(head => head.UUID === detail.UUID)
                        if (newHead) {
                          detail.databaseDocID = newHead.id
                          detail.documentId = parseInt(newHead.documentId)
                          detail.documentIdGeneral = newHead.documentIdGeneral
                          detail.itemName = detail.itemName + (this.inv_Description ? ' ' + this.inv_Description : '')
                        }
                      })
                    }
                    await DocumentDetailService.saveallitems(newDetails)
                  })
                  .catch(err2 => {
                    console.log('err2', err2)
                  })


                  this.dialog = false
                  this.text = this.lang.DocumentSavedOK + response.statusText
                  this.color = 'green'
                  this.snackbar = true
                  this.timeout = 2000
                })
                .catch(err => {
                  this.dialog = false
                  this.text = 'Error post! Greška u snimanju!' + err
                  this.color = 'red'
                  this.snackbar = true
                  this.timeout = 4000
                })
          }
        }

      })
      .catch(err => {
        this.havealert = !this.havealert
        this.havemssgalert = 'Error' + err
      })

      this.saving = false

    },
    async newdocument () {
      try {
        this.$store.dispatch('setDocumentActivHead', {})
        this.$store.dispatch('setDocumentActivItems', [])
        if (this.$store.state.user && this.$store.state.user.vehicles && this.$store.state.user.vehicles === true && this.$store.state.documentActiv === 'ServiceNotes') {
          await this.$router.push({
            name: 'documentcreateservice'
          })
        } else {
          await this.$router.push({
            name: 'documentcreate'
          })
        }
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    openStatus() {
      this.$router.push({name: 'documentstatus'})
    },
    digitalDoc() {
      this.showDigitalDoc = !this.showDigitalDoc
    },
    newWH() {
      this.currWh  = this.$store.state.warehousemarkid ? 'Akt.skl. ' + this.$store.state.warehousemarkid : 1
      const side = this.$store.state.documentSide ? this.$store.state.documentSide : 0
      this.showWarehouse = false
      if (side === 1 || side === 2) {
        this.key += 1
      }
    }
  },
  computed: {
    ...mapGetters({
      wsmarkId: 'NeedWareHouseMarkId',
    }),
  },
  watch: {
    'wsmarkId' () {
      this.newWH()
    },
  },
  components: {
    Documentlist,
    DigitalDocFullList,
    WareHouseSelect
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
